export default function authHeader() {
  if (typeof window === 'undefined') {
    return {};
  }
  const token = JSON.parse(localStorage.getItem("token"));
  if (token) {
    return { Authorization: `Bearer ${token}` };
  } else {
    console.log("not found");
  }
}
